module.exports = __webpack_public_path__ + "af3223eae3c228386e6fa80a6880b4de.jpg";